var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "arrow-left"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.99995 13.75C6.90141 13.7505 6.80377 13.7313 6.71276 13.6935C6.62175 13.6557 6.5392 13.6001 6.46995 13.53L0.46995 7.53003C0.3295 7.3894 0.25061 7.19878 0.25061 7.00003C0.25061 6.80128 0.3295 6.61066 0.46995 6.47003L6.46995 0.470029C6.61213 0.337549 6.80017 0.265426 6.99447 0.268855C7.18877 0.272283 7.37416 0.350995 7.51157 0.488408C7.64898 0.625821 7.7277 0.811206 7.73113 1.00551C7.73455 1.19981 7.66243 1.38785 7.52995 1.53003L2.05995 7.00003L7.52995 12.47C7.6704 12.6107 7.74929 12.8013 7.74929 13C7.74929 13.1988 7.6704 13.3894 7.52995 13.53C7.46071 13.6001 7.37816 13.6557 7.28714 13.6935C7.19613 13.7313 7.09849 13.7505 6.99995 13.75Z",
    fill: "#4B5563"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M15 7.75H1C0.801088 7.75 0.610322 7.67098 0.46967 7.53033C0.329018 7.38968 0.25 7.19891 0.25 7C0.25 6.80109 0.329018 6.61032 0.46967 6.46967C0.610322 6.32902 0.801088 6.25 1 6.25H15C15.1989 6.25 15.3897 6.32902 15.5303 6.46967C15.671 6.61032 15.75 6.80109 15.75 7C15.75 7.19891 15.671 7.38968 15.5303 7.53033C15.3897 7.67098 15.1989 7.75 15 7.75Z",
    fill: "#4B5563"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow-left.c5e9fe8b538eaf5f22be078937c55a58.svg";
export { ForwardRef as ReactComponent };